{{each data}}
<li>
    <div class="li-top">
        <a href="/user/index?uid={{$value.uid}}"><img src="{{$value.avatar}}" alt="" class="auth-img"></a>
        <div class="auth-content">
            <p class="auth-name">{{$value.real_name}}</p>
            <p class="auth-">{{$value.career}}</p>
            <!--<a href="" class="add-follow" data-id="{{$value.id}}">加关注</a>-->
        </div>
    </div>
</li>
{{/each}}
